import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/pagina-nao-encontrada.svg'


const _hoisted_1 = { class: "page-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"error-404-view\" data-v-3fdcd3a1><div class=\"container\" data-v-3fdcd3a1><div class=\"title-error-view col-12\" data-v-3fdcd3a1><h2 class=\"col-12\" data-v-3fdcd3a1>Ops! Este link não está disponível.</h2><p class=\"col-12 text-default\" data-v-3fdcd3a1> Para mais informações, fale com seu contador. </p></div><div class=\"imagem-error-view col-12 my-5\" data-v-3fdcd3a1><img alt=\"Página não encontrada\" src=\"" + _imports_0 + "\" data-v-3fdcd3a1></div></div></div>", 1)),
    _createVNode(_component_Footer)
  ]))
}